import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";

import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";

import { AppComponent } from "./core/containers/app.component";
import { AppModuleShared } from "./app.shared.module";
import { AppRoutingModule } from "./app-routing.module";
import { reducers } from "./root.reducer";
import { EasyAuthService } from "./core/services/easyauth.service";
import { httpInterceptorProviders } from "./core/httpinterceptors";
import { GlobalAppErrorHandler } from "./core/error-handler/app.error-handler";

// ✅ IMPORTANT: SkillsEffects must be registered, otherwise SkillsPageActions.loadPage / SkillSearchBarActions.loadComponent do nothing.
import { SkillsEffects } from "./skill/effects/skill.effects";

export function initEasyAuth(easyAuth: EasyAuthService) {
  return () => easyAuth.loadUser();
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    StoreModule.forRoot(reducers),

    // ✅ Register global effects here so skill nodes load anywhere in the app (skills view + build team dropdowns).
    EffectsModule.forRoot([SkillsEffects]),

    AppModuleShared,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initEasyAuth,
      deps: [EasyAuthService],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalAppErrorHandler },
    ...httpInterceptorProviders,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppBrowserModule {}
